Zone = App.loadClass "grower::viewmodels/data/management_zones/Zone"

class  exports.Layer extends KoModel

    constructor: (data = {}) ->
        super()

        @id         = data.id ? null
        @year       = data.year ? null
        @zone_type  = data.zone_type ? null
        @extra_info = data.extra_info ? {}
        @fields_id  = data.fields_id ? null

        zones = data.zone_areas ? data.areas ? []

        @zone_areas = for i in zones
            new Zone this, i

        #zone_areas = data.zone_areas ? []


    save: (extra_data = {}, callback) =>
        req = $.ajax
            url: "layers/management-zones/add",
            data: @serialize()
            type: 'POST'
            context: extra_data
        .done callback
